import persistReducer from 'redux-persist/es/persistReducer'
import storage from 'redux-persist/lib/storage'
import userAuthSlice from '../slices/auth.slice'
import { REDUX_PERSIST_CONSTANTS } from '../utils/constants'

/**
 * Profile, tenant, site settings — localStorage (shared across tabs).
 */
export const authUserPersistConfig = {
  key: REDUX_PERSIST_CONSTANTS.AUTH_USER,
  storage,
}

export const persistedAuthUserReducer = persistReducer(
  authUserPersistConfig,
  userAuthSlice
)

/** redux-persist key in localStorage for the auth profile slice. */
export const AUTH_USER_LOCAL_STORAGE_KEY = `persist:${REDUX_PERSIST_CONSTANTS.AUTH_USER}`
